import keyMirror from 'keymirror'

export const SETTING_CODE = keyMirror({
  tenderAmountThreshold: null,
  itqTermsId: null,
  tenderTermsId: null,
  docUploadSize: null,
  docUploadTypes: null,
  eCircularAttachmentMaxFiles: null,
  eCircularAttachmentMaxTotalSizeMB: null,
  sppLifecycleEffectiveDate: null,
})
